// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyBHV1qdlHbXqqQiZB6Tpp_FCxKpWwonPlw",
  authDomain: "scrviz.firebaseapp.com",
  projectId: "scrviz",
  storageBucket: "scrviz.appspot.com",
  messagingSenderId: "761157358583",
  appId: "1:761157358583:web:d5b2b4339470a8b94e14f2",
  measurementId: "G-8CGXEG3BHY",
};

export const githubScopes = ["public_repo"];
export const googleScopes = [
    "https://www.googleapis.com/auth/script.projects",
    "https://www.googleapis.com/auth/drive.file",
  ]

export const googleConfig = {
  projectId: "761157358583",
  clientId:
    "761157358583-emu7uqvg0aq59slc1fidu876td4rh3ue.apps.googleusercontent.com",
  apiKey: "AIzaSyB55rWa1ArzKMtuKrRHm5vPrpqKQeRNpdU",
  discoveryDocs: [
    "https://script.googleapis.com/$discovery/rest?version=v1",
    "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
  ],
  scope: googleScopes.join(" "),
};
